module.exports = __webpack_public_path__ + "static/media/pulverizador2.cb821db7.svg";